<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import DocumentUpload from '../Document/DocumentUpload'

export default {
  name: 'OrderDetails',
  components: { 
    DocumentUpload
  },
  mounted () {

  },
  validations () {
    return {
      orderForm: {}
    }
  },
  data () {
    return {
      title: this.$route.meta.title,
      module: this.$route.meta.module,
      headers: { 'Content-Type': 'text/rtf' }
    }
  },
  computed: {
    validation () { 
      return this.$v 
    },
    ...mapState('orders', {
      orderTypeModal: (state) => state.orderTypeModal,
      orderForm: (state) => state.orderForm
    }),
    ...mapState({
      mode: state => state.shared.detailsModal.mode
    }),
    fileTypeInfo () {
      return `Only accepts ${this.fileExtensions} extensions`
    }
  },
  methods: {
    ...mapMutations('orders', [
      'openOrderType',
      'closeOrderType'
    ]),
    ...mapActions('orders', [
      'addNew',
      'select',
      'create',
      'update',
      'remove'
    ]),
    successHandler (response) {
      this.$v.$reset()
    },
    onSelect (student) {
      this.select(student).then(this.$v.$touch)
    },
    onAddAnother () {
      this.addAnother().then(this.successHandler)
    },
    onAddNew () {
      this.addNew().then(this.successHandler)
    },
    onAdd () {
      this.add().then(this.successHandler)
    },
    onUpdate () {
      this.update().then(this.successHandler)
    },
    onRemove () {
      this.$q.dialog(this.removeDialogOptions)
      .then(this.remove)
      .catch(err => err)
    },
  }
}
</script>

<template>
    <div class="details-inner">        
      <div class="sl-row sl-abs">
        <div class="sl-col-12 no-padding">
          <q-card class="">
            <q-tabs
              class="col-12"
              no-pane-border
              align="center"
            >
              <!-- Tabs - notice slot="title" -->
              <q-tab default slot="title" name="details" label="Details"
                :alert="validation.orderForm.$invalid 
                || validation.$invalid" ></q-tab>
              <q-tab slot="title" name="documents" label="Documents"></q-tab>
              <!-- <q-tab slot="title" name="notes" label="Notes"></q-tab> -->

              <!-- Targets -->
              <q-tab-pane name="details" class="fit" >
              </q-tab-pane>
              <q-tab-pane name="documents" class="no-padding">
              </q-tab-pane>
              <q-tab-pane name="notes" class="fit">
              </q-tab-pane>
            </q-tabs>
          </q-card>
          <document-upload
          />
        </div>
        <q-toolbar>
          <q-btn
            v-if="mode === 'edit'"
            color="red"
            label="Remove"
            @click="onRemove()"
          />
          <q-toolbar-title>
          </q-toolbar-title>
          <div class="q-px-sm">
            <q-btn
              v-if="mode === 'edit'"
              class="q-px-md"
              label="Upload"
              color="green"
              @click="openUploadModal()"
            />
          </div>
          <div class="q-px-sm">
            <q-btn
              v-if="mode === 'edit'"
              class="q-px-md"
              color="green"
              label="Save"
              :disable="$v.$invalid"
              @click="onUpdate()"
            />
          </div>
          <div class="q-px-sm">
            <q-btn
              v-if="mode === 'add'"
              class="q-px-md"
              color="green"
              label="Add"
              :disable="$v.orderForm.$invalid"
              @click="onAdd()"
            />
          </div>
          <q-btn outline color="faded" @click.native="closeDetails" label="Cancel" />
        </q-toolbar>
      </div>
    </div>
</template>


<style scoped lang="stylus">
#upload-body {
  overflow: scroll
}
.q-tabs-panes {
  display: flex;
  overflow: scroll;
  max-width: 1400px;
  margin: 0 auto;
}
.sl-row.sl-abs{
  height calc(100% - 110px)
}
</style>